import { Toaster } from "sonner";
import StyleAsia3PLIntakeApp from "components/StyleAsia3PLIntakeApp";

export default function App() {
  return (
    <>
      <StyleAsia3PLIntakeApp />
      <Toaster richColors position="top-center" />
    </>
  );
}
